// import React  from 'react';
import React, {useState, useEffect} from "react";

import IndexContent from "../content/IndexContent";

import Navbar from "../inc/Navbar";
import Banner from "../inc/Banner";
import Footer from "../inc/Footer";

import LoadingBar from 'react-top-loading-bar';

import { Helmet } from "react-helmet-async";

function Home() {
    const [progress, setProgress] = useState(0);

    useEffect(()=>{
        setProgress(100);
    },[])
    return(
        <>
        <Helmet>
            <title>Suvivah | Trusted Matrimonial Platform for Ideal Marriage</title>

            <meta
                name="description"
                content="Suvivah is a trusted matrimonial platform helping individuals and families find compatible life partners based on values, trust, and tradition."
            />

            <meta
                name="keywords"
                content="Suvivah, Matrimony, Marriage, Bengali Matrimony, Ideal Marriage, Life Partner"
            />

            <meta name="robots" content="index, follow" />
            <meta name="author" content="Suvivah" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="theme-color" content="#dc3545" />
            <meta property="og:site_name" content="Suvivah" />
            <meta property="og:locale" content="en_IN" />

            <link rel="canonical" href="https://suvivah.org/" />

            <meta property="og:type" content="website" />
            <meta property="og:title" content="Suvivah - Ideal Matrimonial Platform" />
            <meta property="og:description" content="Find your ideal life partner through Suvivah." />
            <meta property="og:url" content="https://suvivah.org/" />
            <meta property="og:image" content="https://suvivah.org/images/logo.png" />

            <meta name="twitter:card" content="summary_large_image" />
        </Helmet>

        <Navbar />
        <Banner />
        <LoadingBar
            color='#a11800'
            height={4}
            background='#fff4a1'
            loaderSpeed={2000}
            waitingTime={2000}
            shadow={true}
            progress={progress}
            onLoaderFinished={() => setProgress(0)}
        />
        <IndexContent/>
        <Footer />        
        </>
    );
}

export default Home;